export type ExportOption =
  | 'Current Type (All Tiers)'
  | 'Current Type'
  | 'Tier'
  | 'All';

// Matches the ExportActiveFilter enum of the API (sent as ?activeFilter=)
export type ExportActiveFilter = 'Active' | 'Inactive' | 'All';

export const exportActiveFilterOptions: { value: ExportActiveFilter; text: string }[] = [
  { value: 'Active', text: 'Active items only' },
  { value: 'Inactive', text: 'Inactive items only' },
  { value: 'All', text: 'Active and inactive items' },
];
